import PropTypes from 'prop-types';
import React from 'react';
import './SearchResultsDesktop.css';

export default function SearchResultsDesktop (props) {
  let items = null;
  if (props.items && props.items.length > 0) {
    if (props.termType === 'band') {
      items = props.items.map((item, idx) => {
        return (
          <SearchResultBand key={idx} item={item} />
        );
      });
    } else if (props.termType === 'club') {
      items = props.items.map((item, idx) => {
        return (
          <SearchResultClub key={idx} item={item} />
        );
      });
    } else if (props.termType === 'fundraiser') {
      items = props.items.map((item, idx) => {
        return (
          <SearchResultFundraiser key={idx} item={item} />
        );
      });
    } else if (props.termType === 'user') {
      items = props.items.map((item, idx) => {
        return (
          <SearchResultPerson key={idx} item={item} />
        );
      });
    } else if (props.termType === 'team') {
      items = props.items.map((item, idx) => {
        const isMember = props.joinedTeams.indexOf(item.id) >= 0;
        return (
          <SearchResultTeam key={idx} item={item} isMember={isMember} />
        );
      });
    } else if (props.termType === 'school') {
      items = props.items.map((item, idx) => {
        return (
          <SearchResultSchool key={idx} item={item} />
        );
      });
    }
  } else if (props.items && props.items.length === 0) {
    items = [
      <li className="SearchResultsRow clearfix" key={0}>There are no results.</li>,
    ];
  }

  let next = null;
  if (props.hasNextPage) {
    if (props.loading) {
      next = (
        <li className="txt-center">
          <button className="btn btn-link loading-gif"></button>
        </li>
      );
    } else {
      next = (
        <li className="SearchResultsRow clearfix txt-center">
          <button className="btn btn-link" onClick={props.onNextPage}>
            View More Results
          </button>
        </li>
      );
    }
  }

  let resultListClass = props.termType === 'user' ? 'SearchResultsTable' : 'SearchResults';
  return (
    <ul className={resultListClass}>
      {items}
      {next}
    </ul>
  );
}

function SearchResultBand (props) {
  const item = props.item;
  return (
    <li className="SearchResultsRow clearfix">
      <div className="clearfix">
        <div className="SearchResultsRow-avatar">
          <a href={item._links.self.href}><img key={item.id} src={item._links.profile_picture.href} /></a>
        </div>
        <div className="SearchResultsRow-detail">
          <div className="truncatable-line">
            <a className="SearchResultsRow-itemName" href={item._links.self.href}>{item._links.self.title}</a>
          </div>
          {
            item._links.school ? (
              <div className="truncatable-line">
                {item._links.school.title}
              </div>
            ): null
          }
          <div className="truncatable-line">
            {item.city}, {item.state}
          </div>
          <div className="SearchResultsRow-bottom SearchResultsRow-bottom--outlined">
            <div className="btn-group btn-group-justified" role="group">
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.self.href}>
                  Band Page
                </a>
              </div>
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.teams.href}>
                  List of Groups
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
SearchResultBand.propTypes = {
  item: PropTypes.object.isRequired,
};

function SearchResultClub (props) {
  const item = props.item;
  return (
    <li className="SearchResultsRow clearfix">
      <div className="clearfix">
        <div className="SearchResultsRow-avatar">
          <a href={item._links.self.href}><img key={item.id} src={item._links.profile_picture.href} /></a>
        </div>
        <div className="SearchResultsRow-detail">
          <div className="truncatable-line">
            <a className="SearchResultsRow-itemName" href={item._links.self.href}>{item._links.self.title}</a>
          </div>
          <div className="truncatable-line">
            {item.city}, {item.state}
          </div>
          <div className="truncatable-line">
            {item.sport_name}
          </div>
          <div className="SearchResultsRow-bottom SearchResultsRow-bottom--outlined">
            <div className="btn-group btn-group-justified" role="group">
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.self.href}>
                  Club Page
                </a>
              </div>
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.teams.href}>
                  List of Teams
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
SearchResultClub.propTypes = {
  item: PropTypes.object.isRequired,
};

function SearchResultFundraiser (props) {
  const item = props.item;
  return (
    <li className="SearchResultsRow clearfix">
      <div className="clearfix">
        <div className="SearchResultsRow-avatar">
          <a href={item._links.self.href}>
            <img key={item.id} src={item._links.profile_picture.href} />
          </a>
        </div>
        <div className="SearchResultsRow-detail">
          <div className="truncatable-line">
            <a className="SearchResultsRow-itemName" href={item._links.self.href}>{item._links.self.title}</a>
          </div>
          <div className="truncatable-line">
            {item._links.team.title}
          </div>

          <div className="SearchResultsRow-bottom SearchResultsRow-bottom--outlined">
            <div className="btn-group btn-group-justified" role="group">
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.team.href}>
                  Team Page
                </a>
              </div>
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.self.href}>
                  Fundraiser Page
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
SearchResultFundraiser.propTypes = {
  item: PropTypes.object.isRequired,
};

function SearchResultPerson (props) {
  const item = props.item;
  let locationName = null;
  if (item.location && item.location.city_name && item.location.state) {
    locationName = [item.location.city_name, item.location.state].join(', ');
  }
  const url = item._links.showcase ? item._links.showcase.href : item._links.self.href;
  const details = (
    <div className="SearchResultsTableRow-detail">
      <div className="truncatable-line">
        <a className="SearchResultsTableRow-itemName" href={url}>{item.display_name}</a>
      </div>
      {
        item.unconfirmed ? (
          <div className="truncatable-line">
            Unconfirmed
          </div>
        ): null
      }
      {
        item.email ? (
          <div className="truncatable-line">
            <a href={`mailto:${item.email}`}>{item.email}</a>
          </div>
        ): null
      }
      <div className="truncatable-line">
        {locationName}
      </div>
      {
        item.sports_info ? (
          <div className="truncatable-line">
            {item.sports_info.team_name}
          </div>
        ): null
      }
      {
        item.sports_info ? (
          <div className="truncatable-line">
            {item.sports_info.team_title}
          </div>
        ): null
      }
    </div>
  );
  const jerseyPos = [];
  if (item.sports_info) {
    if (item.sports_info.jersey_no) {
      jerseyPos.push('#' + item.sports_info.jersey_no);
    }
    if (item.sports_info.positions) {
      jerseyPos.push(item.sports_info.positions.join(', '));
    }
    if (item.sports_info.role) {
      jerseyPos.push(item.sports_info.role);
    }
  }
  const misc = (
    <div className="SearchResultsTableRow-misc">
      {
        jerseyPos.length > 0 ? (
          <div>{jerseyPos.join(' ')}</div>
        ): null
      }
      {
        item.sports_info.grad_year ? (
          <div>{`Class of ${item.sports_info.grad_year}`}</div>
        ): null
      }
      {
        item._links.parent ? (
          <div>{item._links.parent.title}</div>
        ): null
      }
    </div>
  );

  let trophy = null;
  if (item._links.showcase) {
    trophy = (
      <div className="SeachResultsTableRow-trophy">
        <a href={item._links.showcase.href}>
          <img src="/static/img/showcase/blast_showcase_icon_silver_150px.png" />
        </a>
      </div>
    );
  } else {
    trophy = (<div className="SeachResultsTableRow-trophy"></div>);
  }
  return (
    <li className="SearchResultsTableRow clearfix">
      <div className="SearchResultsTableRow-avatar">
        <a href={url}><img key={item.id} src={item._links.profile_picture.href} /></a>
      </div>
      {details}
      {misc}
      {trophy}
    </li>
  );
}
SearchResultPerson.propTypes = {
  item: PropTypes.object.isRequired,
};

function SearchResultTeam (props) {
  const item = props.item;
  let yearStr = null;
  let activeBegin = new Date(item.active_begin);
  let activeEnd = new Date(item.active_end);
  if (activeBegin.getFullYear() === activeEnd.getFullYear()) {
    yearStr = item.active_begin.slice(0, 4);
  } else {
    yearStr = item.active_begin.slice(0, 4) + '-' + item.active_end.slice(2, 4);
  }
  let locationName = null;
  if (item.location && item.location.city_name && item.location.state) {
    locationName = [item.location.city_name, item.location.state].join(', ');
  }
  let admins = null;
  if (item.administrators_names && item.administrators_names.length > 0) {
    admins = `Admin: ${item.administrators_names.join(', ')}`;
  }
  let joinBtn = null;
  if (!props.isMember) {
    joinBtn = (
      <a type="button" className="btn btn-link" href={item._links.join.href}>
        Join
      </a>
    );
  } else {
    joinBtn = (
      <span>You're a member</span>
    );
  }
  return (
    <li className="SearchResultsRow clearfix">
      <div className="clearfix">
        <div className="SearchResultsRow-avatar">
          <a href={item._links.self.href}><img key={item.id} src={item._links.profile_picture.href} /></a>
        </div>
        <div className="SearchResultsRow-detail">
          <div className="truncatable-line">
            <a className="SearchResultsRow-itemName" href={item._links.self.href}>{item.display_name}</a>
          </div>
          {
            item._links.band ? (
              <div className="truncatable-line">
                Band: <a href={item._links.band.href}>{item._links.band.title}</a>
              </div>
            ): null
          }
          {
            item._links.club ? (
              <div className="truncatable-line">
                Club: <a href={item._links.club.href}>{item._links.club.title}</a>
              </div>
            ): null
          }
          <div className="truncatable-line">
            <div className="toright">
              {yearStr}
            </div>
            {item.team_title}
          </div>
          <div className="truncatable-line">
            {locationName}
          </div>
          <div className="truncatable-line">
            {admins}
          </div>
        </div>

      </div>
      <div className="SearchResultsRow-bottom SearchResultsRow-bottom--outlined">
        <div className="btn-group btn-group-justified" role="group">
          <div className="btn-group" role="group">
            <a type="button" className="btn btn-link" href={item._links.self.href}>
              Team Page
            </a>
          </div>
          <div className="btn-group" role="group">
            {joinBtn}
          </div>
        </div>
      </div>
    </li>
  );
}
SearchResultTeam.propTypes = {
  item: PropTypes.object.isRequired,
};

function SearchResultSchool (props) {
  const item = props.item;
  let locationName = null;
  if (item.location && item.location.city_name && item.location.state) {
    locationName = [item.location.city_name, item.location.state].join(', ');
  }
  let rep = null;
  if (item._embedded && item._embedded.current_rep) {
    rep = item._embedded.current_rep;
  }
  let formattedDate;
  if (rep) {
    const activeBegin = new Date(rep.active_begin)
    const options = { month: 'numeric', year: '2-digit' };
    formattedDate = new Intl.DateTimeFormat('en-US', options).format(activeBegin);
  }

  return (
    <li className="SearchResultsRow clearfix">
      <div className="clearfix">
        <div className="SearchResultsRow-avatar">
          <a href={item._links.self.href}><img key={item.id} src={item._links.profile_picture.href} /></a>
        </div>
        <div className="SearchResultsRow-detail">
          {
            rep ? (
              <div className="pull-right text-right">
                <div className="truncatable-line">Rep: <a href={rep._links.user.href}>{rep._links.user.title}</a> since {formattedDate} </div>
                <div className="truncatable-line"><a href={'mailto:'+rep.email}>{rep.email}</a></div>
              </div>
            ): item.pending_rep ? (
              <div className="pull-right text-right">
                <div className="truncatable-line">Rep: Pending</div>
              </div>
            ): null
          }
          <div className="truncatable-line">
            <a className="SearchResultsRow-itemName" href={item._links.self.href}>{item.display_name}</a>
          </div>
          <div className="truncatable-line">
            {locationName}
          </div>

          <div className="SearchResultsRow-bottom SearchResultsRow-bottom--outlined">
            <div className="btn-group btn-group-justified" role="group">
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.scoreboard.href}>
                  Scoreboard
                </a>
              </div>
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.teams.href}>
                  Teams
                </a>
              </div>
              <div className="btn-group" role="group">
                <a type="button" className="btn btn-link" href={item._links.join.href}>
                  Join a Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
SearchResultSchool.propTypes = {
  item: PropTypes.object.isRequired,
};
